import useSWR from "swr";
import fetcher from "./fetcher";

// A null influencerId means the whole moderation queue, so opting out of the
// request needs its own flag rather than an absent id.
export default function useImageApprovals(influencerId = null, enabled = true) {
  const params = influencerId ? `?influencer_id=${influencerId}` : "";
  const url = `/api/imageApproval/pending${params}`;

  const { data, error, mutate } = useSWR(enabled ? url : null, fetcher);

  return {
    approvals: data?.approvals ?? [],
    isLoading: !data && !error,
    error,
    refresh: mutate,
  };
}
